import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { concatenateTitle } from 'utils/concatenate-title-object';

import OffersNavigation from 'components/Offers/Navigation';
import Breadcrumbs from 'components/Breadcrumbs';

import styles from './OffersHeader.scss';

const offersHeaderDefaultPropTitle = {};

const OffersHeader = memo(({ breadcrumbs, navigation, title = offersHeaderDefaultPropTitle }) => {
  const concatenatedTitle = concatenateTitle(title);
  const hasNavigation = navigation && navigation.length > 0;
  const breadcrumbProps = {
    breadcrumbs,
    white: hasNavigation,
  };
  const navigationProps = {
    navigation,
    title: {
      display: true,
      text: concatenatedTitle,
    },
  };

  return (
    <div className={hasNavigation ? styles.offersTypeHeader : styles.offersHeader}>
      {breadcrumbs && <Breadcrumbs {...breadcrumbProps} />}
      <OffersNavigation {...navigationProps} />
    </div>
  );
});

OffersHeader.displayName = 'OffersHeader';

OffersHeader.propTypes = {
  breadcrumbs: PropTypes.arrayOf(PropTypes.shape({})),
  navigation: PropTypes.arrayOf(PropTypes.shape({})),
  title: PropTypes.shape({
    highlight: PropTypes.string,
    offersHighlight: PropTypes.string,
    suffix: PropTypes.string,
    text: PropTypes.string,
  }),
};

export default OffersHeader;
